var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('item-list-component',{attrs:{"item-type":`premiumMarketUpload`,"member-key":_vm.UserInfo.mb_no}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }